export const ROLES = {
    JOB_SEEKER: 'ROLE_JOBSEEKER'
}